/**
 * Controller: PartnersListCategoriesRemoveModal
 */
angular.module('acme.view.application.partners.list.categories.removeModal.controllers', [])
.controller('PartnersListCategoriesRemoveModalController', [ '$scope', '$uibModalInstance', 'currentCategory', function ($scope, $uibModalInstance, currentCategory) {

    $scope.errors = [];

    $scope.model = {
      name: currentCategory.name
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);